/** Defaults match `config_settings` ids 59–60 (`speakUp` group). */

export const DEFAULT_SPEAK_UP_BUTTON_TEXT = 'Speak Up';

export const DEFAULT_SPEAK_UP_F2SU_POPUP_DESCRIPTION =
  "Choose how you'd like to share with us. Your choice determines who receives your message and how it's handled.";
